export default __webpack_public_path__ + "static/media/Cloese.e0ed3954.svg";